var echarts = require("echarts");

export function renderChart(resultRadar) {
  var indicators = new Array();
  var valuesRadar = new Array();
  Object.entries(resultRadar)
    .sort()
    .reverse()
    .map((values) => {
      indicators.push({ name: values[1].label, max: 20, fontSize: 24 });
      valuesRadar.push(Math.min(Math.max(values[1].value, 0), 20));
    });
  console.log(valuesRadar);

  const chart = echarts.init(null, null, {
    renderer: "svg",
    ssr: true,
    width: 800,
    height: 800,
  });

  chart.setOption({
    color: ["#183051"],
    backgroundColor: "rgba(255,238,255,0)",

    tooltip: {
      transitionDuration: 0,
      formatter: function () {
        return "<div style='visibility: hidden;'> </div>";
      },
      position: "this.cbToolTipPosition",
    },

    alignTicks: false,
    //  scale: "true",

    radar: [
      {
        alignTicks: false,
        indicator: indicators,
        axisLabel: {
          fontSize: 24,
        },

        radius: 240,
        startAngle: 90,
        splitNumber: 5,
        shape: "circle",
        name: {
          formatter: "{value}",
          textStyle: {
            color: "#005960",
          },
          fontWeight: "bold",
          fontSize: 28,
          alignTicks: false,
        },

        axisLine: {
          lineStyle: {
            color: "#005960",
          },
          alignTicks: false,
        },
        splitLine: {
          lineStyle: {
            color: "rgba(211, 253, 250, 0.8)",
          },
          alignTicks: false,
        },
        splitArea: {
          areaStyle: {
            color: ["#4C8A8F", "#fef7f7"],
          },
          alignTicks: false,
        },
      },
    ],
    series: [
      {
        name: "xp",
        type: "radar",
        lineStyle: {
          width: 4,
        },
        /* emphasis: {
          focus: "self",
          lineStyle: {
            width: 5,
          },
        },*/
        alignTicks: false,

        showSymbol: true,

        data: [
          {
            value: valuesRadar,
            name: "Data A",
            symbolSize: 12,
            areaStyle: {
              color: "rgba(164,144,111,0,9)",
              alignTicks: false,
            },
            alignTicks: false,
          },
        ],
      },
    ],
  });

  return chart;
}
